import React from 'react';
import { Skeleton } from '@landr/maestro';
import * as Styled from './Title.styled';

const Title: React.FC<{ isLoading?: boolean }> = ({ children, isLoading }) => {
    if (isLoading) {
        return <Skeleton width="80%" height="20px" mt={4} mb={8} />;
    }

    return (
        <Styled.Title size="sm" fontWeight="bold">
            {children}
        </Styled.Title>
    );
};

Title.displayName = 'Card.Title';

export default Title;
